import React from "react";
import ConfirmationModalComponent from "./ConfirmationModalComponent";
export default class PromiseModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      message:""
    };

    this.promiseInfo = {};
  }

  show = async (position) => {
    
    return new Promise((resolve, reject) => {
      this.promiseInfo = {
        resolve,
        reject
      };
      const message=`Click 'Retry' to upload image at position number ${position+1} after fixing internet connection or click 'Cancel' to upload next image`;
      this.setState({
        show: true,
        message:message
      });
    });
  };

  hide = () => {
    this.setState({
      show: false
    });
  };

  render() {
    const { show ,message} = this.state;
    const { resolve } = this.promiseInfo;
    return (
      <ConfirmationModalComponent
        onConfirm={() => {
          this.hide();
          resolve(true);
        }}
        onCancel={() => {
          this.hide();
          resolve(false);
        }}
        cancelButtonName="Cancel"
        confirmButtonName="Retry"
        show={show}
        title={"Check your internet connection"}
        message={message}

      />
    );
  }

  getResolve() {
    // Using a no-op function as a fallback in case resolve is not set
    const { resolve = () => { /* No-op: Placeholder function for resolve */ } } = this.promiseInfo || {};
    return result => {
      resolve(result);  // Resolve the promise with the result
      this.hide();      // Hide the modal after resolving
    };
  }
  
  getReject() {
    // Using a no-op function as a fallback in case reject is not set
    const { reject = () => { /* No-op: Placeholder function for reject */ } } = this.promiseInfo || {};
    return err => {
      reject(err);      // Reject the promise with the error
      this.hide();      // Hide the modal after rejecting
    };
  }
  
}
